import axios from 'axios';
import * as actions from './actionsTypes';
import messages from '../../messages';
import WorkFlowBlockServices from './workflowblock.services';
import toastr from 'toastr';

export const getWorkflowBlocks = (filters, type) => async dispatch => {
  try {
    dispatch({
      type: actions.LOADING_WORKFLOWBLOCKS,
      payload: true
    });

    const resp = await WorkFlowBlockServices.getWorkFlowsBlocks(filters, type);
    
    dispatch({
      type: actions.GET_WORKFLOWBLOCKS,
      payload: {
        workflowBlocks: resp.data.data,
        workflowBlockLength: resp.data.count
      }
    });
    dispatch({
      type: actions.WORKFLOWBLOCK_FAIL,
      payload: ''
    });
    dispatch({
      type: actions.WORKFLOWBLOCK_FORM_FAIL,
      payload: ''
    });
  } catch (ex) {
    let message = '';
    if (axios.isAxiosError(ex)){
      if(ex.response?.data){
        message = ex.response.data.message;
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.WORKFLOWBLOCK_FAIL,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.LOADING_WORKFLOWBLOCKS,
      payload: false
    });
  }
}

export const getWorkflowBlock = (id, type) => async dispatch => {
  try {
    dispatch({
      type: actions.LOADING_WORKFLOWBLOCK,
      payload: true
    });
    const resp = await WorkFlowBlockServices.getWorkFlowBlock(id, type);
    dispatch({
      type: actions.GET_WORKFLOWBLOCK,
      payload: resp.data
    });
  } catch (ex) {
    let message = '';
    if (axios.isAxiosError(ex)){
      if(ex.response?.status){
        switch (ex.response?.status) {
          case 404:
            message = messages.notFound;
            break;
          case 500:
            message = `${messages.errorMessage} ${ex.message}`;
            break;
          default:
            break;
        }
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
      if(ex.response?.data){
        message = ex.response.data.message;
      }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.WORKFLOWBLOCK_FAIL,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.LOADING_WORKFLOWBLOCK,
      payload: false
    });
  }
}

const handleFormErrors = errors => {
  let message = null;
  const { nombre, descripcion, fecha_inicio, fecha_fin, estado, posicion, workflow } = errors;
  if(nombre){
    message = nombre;
  }
  if(descripcion){
    if(typeof message === 'object' && message !== null){
      message = [...message, descripcion];
    }else{
      message = descripcion
    }
  }
  if(fecha_inicio){
    if(typeof message === 'object' && message !== null){
      message = [...message, fecha_inicio];
    }else{
      message = fecha_inicio;
    }
  }
  if(fecha_fin){
    if(typeof message === 'object' && message !== null){
      message = [...message, fecha_fin];
    }else{
      message = fecha_fin;
    }
  }
  if(estado){
    if(typeof message === 'object' && message !== null){
      message = [...message, estado];
    }else{
      message = estado;
    }
  }
  if(posicion){
    if(typeof message === 'object' && message !== null){
      message = [...message, posicion];
    }else{
      message = posicion;
    }
  }
  if(workflow){
    if(typeof message === 'object' && message !== null){
      message = [...message, workflow];
    }else{
      message = workflow;
    }
  }
  return message;
}

export const saveWorkflowBlock = (data, type) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_WORKFLOWBLOCK,
      payload: true
    });
    const resp = await WorkFlowBlockServices.saveWorkflowBlock(data, type);
    const { workflowBlocks, workflowBlockLength } = getState().workflowBlock;
    dispatch({
      type: actions.GET_WORKFLOWBLOCKS,
      payload: {
        workflowBlocks: [...workflowBlocks, resp.data],
        workflowBlockLength: workflowBlockLength + 1
      }
    });
    dispatch({
      type: actions.WORKFLOWBLOCK_FORM_FAIL,
      payload: null
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)){
      if(ex.response?.status){
        switch (ex.response.status) {
          case 400:
            message = handleFormErrors(ex.response.data);
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText
            break;
          default:
            message = ex.response.data;
            break;
        }
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.WORKFLOWBLOCK_FORM_FAIL,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.SAVE_LOADING_WORKFLOWBLOCK,
      payload: false
    });
  }
}

export const editWorkflowBlock = (data, index, id, type) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_WORKFLOWBLOCK,
      payload: true
    });
    const resp = await WorkFlowBlockServices.editWorkFlowBlock(id, data, type);
    const { workflowBlocks, workflowBlockLength } = getState().workflowBlock;
    workflowBlocks[index] = resp.data;
    dispatch({
      type: actions.GET_WORKFLOWBLOCKS,
      payload: {
        workflowBlocks: workflowBlocks,
        workflowBlockLength: workflowBlockLength
      }
    });
    dispatch({
      type: actions.WORKFLOWBLOCK_FORM_FAIL,
      payload: null
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)){
      if(ex.response?.status){
        switch (ex.response.status) {
          case 400:
            message = handleFormErrors(ex.response.data);
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText
            break;
          default:
            message = ex.response.data;
            break;
        }
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.WORKFLOWBLOCK_FORM_FAIL,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.SAVE_LOADING_WORKFLOWBLOCK,
      payload: false
    });
  }
}

export const deleteWorkflowBlock = (id, index, type) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_WORKFLOWBLOCKS,
      payload: true
    });
    await WorkFlowBlockServices.deleteWorkFlowBlock(id, type);
    const { workflowBlocks, workflowBlockLength } = getState().workflowBlock;
    workflowBlocks.splice(index, 1);
    dispatch({
      type: actions.GET_WORKFLOWBLOCKS,
      payload: {
        workflowBlocks: workflowBlocks,
        workflowBlockLength: workflowBlockLength - 1
      }
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)){
      if(ex.response?.status){
        switch (ex.response.status) {
          case 404:
            message = messages.notFound
            break;
          case 500:
            message = messages.errorMessage + ex.message;
            break;
          default:
            message = ex.response.data;
            break;
        }
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.WORKFLOWBLOCK_FAIL,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.LOADING_WORKFLOWBLOCKS,
      payload: false
    });
  }
}